import React from "react";
import {
  useDeleteDepartmentMutation,
  useFetchDepartmentsQuery,
} from "../../../store";
import Box from "@mui/material/Box";
import ListHeader from "../managementShared/ListHeader";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "./utils/columns";
import ManagementToolbar from "../managementShared/ManagementToolbar";
import {
  CONFIRM_DIALOG,
  DEPARTMENT_DIALOG,
} from "../../../store/slices/utils/dialogEnum";
import { useDispatch, useSelector } from "react-redux";
import { setDepartment } from "../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import CustomConfirmDialog from "../../../components/shared/CustomConfirmDialog";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import DepartmentForm from "./components/DepartmentForm";

const Departments = () => {
  const dispatch = useDispatch();
  const { data: departments, isLoading } = useFetchDepartmentsQuery();
  const { department } = useSelector((state) => state.managementSlice);
  const { departmentDialogOpen } = useSelector((state) => state.dialogSlice);
  const [deleteDepartment, { isLoading: deleteDepartmentLoading }] =
    useDeleteDepartmentMutation();
  const handleUpdate = (department) => {
    dispatch(setDepartment(department));
    dispatch(openDialog(DEPARTMENT_DIALOG));
  };

  const handleDelete = (department) => {
    dispatch(setDepartment(department));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setDepartment(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const postDelete = () => {
    deleteDepartment(department.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };
  return (
    <Box
      sx={{
        height: "auto",
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Departmanlar" />
      {
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Departman Silme"
          text="Bu departmanı silmek istediğinize emin misiniz?"
          isLoading={deleteDepartmentLoading}
          handleClose={closeDelete}
        />
      }
      {departmentDialogOpen && <DepartmentForm />}
      <DataGrid
        rows={departments?.data || []}
        loading={isLoading}
        disableColumnMenu
        columns={columns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={DEPARTMENT_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default Departments;
